// @flow

import ko from 'rgs-knockout';
import type { Observable, ObservableArray } from 'rgs-knockout';
import { createJSableEntityListMapExtender, JSable } from 'jsable';

// tree
import type { TTreeItemModel } from 'rgs-nfd-ui-kit/ko-components/tree/tree-data-model';


export default class TreeNodeModel extends JSable {
	show: Observable<boolean>;
	parent: Observable<number>;
	Data: Object<TTreeItemModel>;
	Children: ObservableArray<TreeNodeModel>;

	constructor (itemModel: TTreeItemModel, parent?: TreeNodeModel) {
		super();
		this.show = ko.observable(false).extend({ toFromJS: true });
		this.parent = parent;
		this.level = ko.constant(parent ? parent.level() + 1 : 1);
		this.Data = new itemModel(this);
		this.Children = ko.observableArray([]).extend(createJSableEntityListMapExtender(
			TreeNodeModel, [itemModel, this]
		));

		this.hasChildren = this._hasChildren.bind(this);
		this.isRoot = ko.pureComputed(this._isRoot.bind(this));
		this.toggle = this._toggle.bind(this);
		this.isOpen = this._isOpen.bind(this);
		this.isClose = this._isClose.bind(this);
	}

	_isRoot () {
		return this.level() === 1;
	}

	_hasChildren () {
		return this.Children().length > 0;
	}

	_toggle () {
		this.show(!this.show());
	}

	_isOpen () {
		return this.show() === true;
	}

	_isClose () {
		return this.show() === false;
	}
}
